import { isBrowser } from '@utils/isBrowser';

export const useUrlHasParam = (param: string) => {
  if (!isBrowser()) return false;
  const params = new URLSearchParams(window.location.search);
  return params.has(param);
};
